import React from 'react';
import styled from 'styled-components';
import { searchValueInText } from '../../utils';
import PlaceholderEmpty from '../PlaceholderEmpty';
import OPTIONS from '../ViewsSelector/options';

const option = OPTIONS.find((o) => o.value === 'summary') || {};
const ENTITY = option.text || 'AI Summary';
const ICON = option.icon;

const Container = styled.li`
  margin: 16px;
  line-height: 1.3em !important;
`;

const AiSummary = ({ summary, searchValue }) => {
  if (!summary) return <PlaceholderEmpty entity={ENTITY} icon={ICON} />;

  return <Container className="TranscriptItem__text">{searchValueInText(summary, searchValue)}</Container>;
};

export default AiSummary;
